/**
 * СРОК РАБОТЫ СБОРКИ — единственное место, где он задаётся. [12.0.40]
 *
 * Сборка работает ДО этой даты (граница — полночь по UTC начала этого дня).
 * За две недели до неё программа начинает предупреждать, после — показывает
 * окно «Срок этой сборки истёк». Данные при этом не трогаются никогда.
 *
 * КАК ПРОДЛИТЬ
 *   Проще всего — запустить srok.cmd в этой папке: он спросит дату,
 *   проверит её и запишет сюда сам.
 *   Или поправить дату ниже вручную, в кавычках, в виде ГГГГ-ММ-ДД.
 *
 * ПОСЛЕ ПРАВКИ — СОБРАТЬ ЗАНОВО. Дата вшивается в программу при сборке:
 *   компьютер          — desktop.cmd (или npm run desktop:dist — установщик);
 *   сайт и смартфоны   — npm run build:web, затем npm run deploy.
 * Смартфоны получат новую дату сами, при следующем открытии сайта.
 *
 * Проверка test.cmd упадёт, если дата записана с ошибкой, — чтобы опечатка
 * не уехала к коллегам.
 */
export default '2027-03-01';
